import { createApi } from "../axiosInstance";
const api = createApi("myFPO");

export const getMyFPO = () => api.get("/fpo");
export const getMyFPOById = (id) => api.get(`/fpo/${id}`);
export const createMyFPO = (data) => api.post("/fpo", data);
export const updateMyFPO = (id, data) => api.patch(`/fpo/${id}`, data);
export const deleteMyFPO = (id) => api.delete(`/fpo/${id}`);
// { bankDetails: [{ id?, bankName, branchName, accountNumber, ifscCode, accountHolderName }], deletedBankDetails: [id] }
// - a row with an id updates that account, one without adds a new account
export const updateFpoBankDetails = (fpoId, data) => api.patch(`/fpo/${fpoId}/bank-details`, data);

export const createAnonymousFpc = (data) => api.post("/fpo/anonymous", data);

export const getFposByStatus = (status) => api.get(`/fpo?status=${status}`);
export const approveFpo = (fpoId, data) => api.patch(`/fpo/${fpoId}/approve`, data);
export const rejectFpo = (fpoId, data) => api.patch(`/fpo/${fpoId}/reject`, data);

export const approveUser = (userId, data) => api.patch(`/users/${userId}/approve`, data);
export const rejectUser = (userId, data) => api.patch(`/users/${userId}/reject`, data);

export const requestSubscription = (userId, subscriptionPlanId, serviceKey) =>
  api.patch(`/users/${userId}/subscribe`, { subscriptionPlanId, serviceKey });
export const declineSubscription = (userId) => api.patch(`/users/${userId}/subscribe/decline`);
export const getSubscriptionHistory = () => api.get("/subscriptions/history");

// Per-request tracking (subscription_request table) - a user can hold more than one
// simultaneous pending request (a plan change and a separate service unlock, say), each
// independently visible and actionable instead of one silently overwriting the other.
export const getUserSubscriptionRequests = (userId, status) =>
  api.get(`/users/${userId}/subscription-requests`, { params: status ? { status } : {} });
export const getAllPendingSubscriptionRequests = () => api.get("/subscription-requests");
export const approveSubscriptionRequest = (requestId, data) =>
  api.patch(`/subscription-requests/${requestId}/approve`, data);
export const declineSubscriptionRequest = (requestId) =>
  api.patch(`/subscription-requests/${requestId}/decline`);

export const createUser = (data) => api.post("/user", data);
// The registration's mobile number code (fpo RegistrationOtpController): the code comes with the createUser /
// createAnonymousFpc answer (data.verification); verify → { next: "PAYMENT" | "DONE" }
export const verifyRegistrationOtp = (mobileNo, code) => api.post("/registration/otp/verify", { mobileNo, code });
export const resendRegistrationOtp = (mobileNo) => api.post("/registration/otp/resend", { mobileNo });
export const getUsers = (params = {}) => api.get("/users", { params });
export const getUsersId = (id) => api.get(`/users/${id}`);
export const createUsers = (data) => api.post("/users", data);
export const updateUsers = (id, data) => api.patch(`/users/${id}`, data);
export const deleteUsers = (id) => api.delete(`/users/${id}`);
